import { PageFilter } from './page-filter';

export class ProjectFilter extends PageFilter {
    author?: string;
    onlyMyProjects?: boolean;
    projectType?: number;
    search?: string;
}
